import type {GqlFetchFn} from "@repo/data-gql";
import {Errors, KAError} from "@repo/logging";
import {RequestInfo} from "@repo/shared-core";

import {UserSpinoffsOfProgramFetcher} from "./project-list-fetchers/user-spinoffs-of-program-fetcher.ts";

/**
 * TODO(somewhatabstract, JIRA-XXXX):
 * VideoTranscript import is untyped and needs TypeScript-typing before we can
 * type this strongly.
 */
type VideoTranscript = any; // VideoTranscript from "../transcripts-package/transcripts.js";

export const loadTranscript = (youtubeId: string): Promise<VideoTranscript> => {
    return new Promise((resolve, reject) => {
        import("../transcripts-package/transcripts.ts").then(
            ({VideoTranscript}) => {
                const transcript = new VideoTranscript({
                    youtubeId,
                    kaLocale: RequestInfo.kaLocale,
                });

                transcript.fetch({
                    success: () => {
                        if (!transcript.hasValid()) {
                            reject(
                                new KAError(
                                    "Transcript is missing",
                                    Errors.Internal,
                                ),
                            );
                        }

                        resolve(transcript);
                    },
                });
            },
        );
    });
};

// Returns a promise that resolves to an empty array if the user has no
// spinoffs of the given project ID, and to a non-empty array if the user has
// any spinoffs.
// TODO(benchristel): this could be simplified if numProjectSpinoffs in
// scratchpad-view.jsx were changed to a boolean hasProjectSpinoffs.
export const loadOneUserSpinoff = (
    id: number | string,
    gqlFetch: GqlFetchFn,
): Promise<ReadonlyArray<unknown>> => {
    const fetcher = new UserSpinoffsOfProgramFetcher({
        gqlFetch,
        spinoffOrigin: {kind: "PROJECT", programOrContentId: String(id)},
        itemsPerPage: 1,
    });
    return fetcher.fetch({sort: "RECENT"}).then((resp) => resp.scratchpads);
};
